<template>
    <CompassPopover
        :isVisible="visible"
        triggerRef="notification-popover-trigger"
        customClass="notifications-popover"
        placement="bottom"
        noCloseOnClickOutside=".notification-actions-container__menu"
        @close="visible = false"
    >
        <div>
            <el-tabs v-model="activeTab" @tab-click="handleChangeTab">
                <el-tab-pane
                    :label="$t.__('header.Notifications.notifications')"
                    name="notifications"
                >
                    <NotificationsList
                        v-if="visible && activeTab === 'notifications'"
                        :unreadNotificationsCounter="unreadNotificationsCounter"
                    />
                </el-tab-pane>
                <el-tab-pane :label="$t.__('header.Notifications.alert')" name="alerts">
                    <ul v-if="alerts && hasAlertsSetuped" id="alerts-list">
                        <li
                            v-for="(alert, name) in alerts"
                            :id="'notif-' + alert.name"
                            :key="name"
                            class="headnotif p-1"
                        >
                            <div class="headnotif-header br" @click="triggerAlertCallback(alert)">
                                <div class="label label-nobackground">
                                    <span
                                        :class="
                                            'spanLabel spanLabelNotif ' +
                                            (alert.nbAlerts > 0
                                                ? 'spanLabel-red'
                                                : 'spanLabel-lightgrey-disabled')
                                        "
                                    >
                                        {{ alert.nbAlerts > 1000 ? '1000+' : alert.nbAlerts }}
                                    </span>
                                </div>
                                <span class="name">{{ alert.txt }}</span>
                            </div>
                            <div class="headnotif-detail hidden"></div>
                        </li>
                    </ul>
                    <div v-else-if="alerts && !hasAlertsSetuped" class="placeholder">
                        <p>{{ $l10n.__("Aucune alerte n'est paramétrée") }}</p>
                        <CompassButton
                            :label="$t.__('header.Notifications.configure_alert')"
                            class="mb-2"
                            @click="redirectToProfilPreferences"
                        />
                    </div>
                    <div v-else class="placeholder">
                        <p>{{ $l10n.__('Chargement des alertes') }}</p>
                        <br />
                        <i class="fa fa-spin fa-cog fa-blue fa-30"></i>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <CompassIconButton
                icon="settings-fill"
                class="notifications__settings-icon"
                @click="redirectToProfilPreferences"
            />
        </div>
    </CompassPopover>
    <CompassTooltip
        ref="notification-popover-trigger"
        :content="$t.__('header.Notifications.notifications')"
        placement="bottom"
        :delay="{ show: 1000, hide: 0 }"
        :arrow="false"
    >
        <div class="notifications__icon-container">
            <CompassIcon icon="notification" class="notifications__icon" />
            <span v-if="unreadNotificationsCounter" class="notifications__badge">
                {{ unreadNotificationsCounter > 99 ? '99+' : unreadNotificationsCounter }}
            </span>
        </div>
    </CompassTooltip>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import NotificationsList from 'vcomponents/notifications/NotificationsList.vue';
import NotificationApi from 'api/notification/Notification';
import LocalStorage from 'Core/commons/LocalStorage';

export default {
    components: {
        NotificationsList,
    },
    data() {
        return {
            alerts: null,
            activeTab: null,
            visible: false,
            unreadNotificationsCounter: null,
            localstorage: new LocalStorage('notification', 'last_tab'),
            localStorageCountUnreadNotif: null,
        };
    },

    computed: {
        /**
         * @returns bool
         */
        hasAlertsSetuped() {
            if (!this.alerts) {
                return false;
            }

            if (Object.values(this.alerts).length === 0) {
                return false;
            }

            return true;
        },
    },
    watch: {
        unreadNotificationsCounter(newVal, oldVal) {
            if (newVal !== oldVal && newVal !== this.localStorageCountUnreadNotif.get('payload')) {
                this.localStorageCountUnreadNotif.setex(newVal, 120000); //120 000 ms => 2 minutes for ttl
            }
        },
    },
    created() {
        const staffId = this.$store.getters['user/getUser'].id;
        this.localStorageCountUnreadNotif = new LocalStorage(
            'notification',
            `count_unread_${staffId}`,
        );
        this.activeTab =
            this.localstorage.get() !== null ? this.localstorage.get() : 'notifications';
        if (this.activeTab === 'alerts') {
            this.getAlerts();
        }
        EventBus.on('notification:unread:decrement', this.decrementUnreadNotificationCounter);
        EventBus.on('notification:unread:increment', this.incrementUnreadNotificationCounter);
        EventBus.on('notification:panel:close', this.closeNotificationPopover);
        EventBus.on('notification:unread:resetUnreadNotifCounter', this.resetUnreadNotifCounter);
    },
    unmounted() {
        EventBus.off('notification:unread:decrement', this.decrementUnreadNotificationCounter);
        EventBus.off('notification:unread:increment', this.incrementUnreadNotificationCounter);
        EventBus.off('notification:panel:close', this.closeNotificationPopover);
        EventBus.off('notification:unread:resetUnreadNotifCounter', this.resetUnreadNotifCounter);
    },
    mounted() {
        // If refacto getElementById('headermenu_notif'), remove also id in NavItem.vue pls
        document
            .getElementById('headermenu_notif')
            .addEventListener('click', this.toggleNotificationPopover, false);
        this.getUnreadNotificationsCounter();
    },
    methods: {
        /**
         * notification object is sent by backend (so the eval).
         * @todo Refactorise when logic will be deported on frontend.
         *
         * @var {Object} notification
         */
        triggerAlertCallback(alert) {
            if (alert.nbAlerts > 0 || (alert.forceAction && alert.forceAction === 'Y')) {
                eval(alert.action);
            } else if (alert.nbAlerts === 0 && alert.offAction && alert.offAction !== '') {
                eval(alert.offAction);
            }
        },
        getAlerts() {
            if (!document.hidden) {
                //Old api route for alerts fetching
                this.$ajax.get('/alerts').then((response) => {
                    this.alerts = response.data;
                });
            }
        },
        handleChangeTab(tab) {
            this.localstorage.set(tab.paneName);

            if (tab.paneName === 'alerts') {
                this.getAlerts();
            }
        },
        toggleNotificationPopover() {
            this.visible = !this.visible;
        },
        getUnreadNotificationsCounter() {
            if (this.localStorageCountUnreadNotif.get('payload') !== null) {
                this.unreadNotificationsCounter = this.localStorageCountUnreadNotif.get('payload');
            } else {
                NotificationApi.getUnreadNotifications()
                    .then((res) => {
                        this.unreadNotificationsCounter = res.data.pagination.total;
                    })
                    .catch(() => {
                        Push.error(
                            this.$l10n.__(
                                'Une erreur est survenue lors de la récupération des notifications.',
                            ),
                        );
                    });
            }
        },
        incrementUnreadNotificationCounter() {
            this.localstorage.set('notifications');
            this.activeTab = 'notifications';
            this.unreadNotificationsCounter++;
        },
        decrementUnreadNotificationCounter() {
            if (this.unreadNotificationsCounter > 0) {
                this.unreadNotificationsCounter--;
            }
        },
        closeNotificationPopover() {
            if (this.visible === true) {
                this.visible = false;
            }
        },
        resetUnreadNotifCounter() {
            this.unreadNotificationsCounter = 0;
        },

        redirectToProfilPreferences() {
            return goToUrl('/?_f=profilPreferences&action=notificationInApp');
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

#compass-popover-container {
    .notifications-popover {
        z-index: 2001 !important;

        .compass-popover__content {
            width: 496px;
            min-height: 582px;
            padding: var(--spacing-3) var(--spacing-1) 0;
        }

        .el-tabs__header {
            margin-bottom: 0 !important;

            &.is-top {
                margin: 0;
            }

            .el-tabs__nav-wrap::after {
                right: 8px;
                left: 8px;
                width: auto;
            }

            .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav.is-top {
                #tab-notifications.el-tabs__item.is-top {
                    padding-left: 8px !important;
                }
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.notifications {
    &__icon-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 28px;
        width: 28px;
    }

    &__badge {
        position: absolute;
        top: 2px;
        left: 14px;
        height: 14px;
        background-color: var(--colors-common-background-alert-default);
        border-radius: 44px;
        padding: 0 var(--spacing-0);
        font-family: var(--font-families-lato);
        font-weight: 600;
        font-size: 10.5px;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: center;
        color: var(--colors-common-text-standard-on-color);
    }

    &__settings-icon {
        position: absolute;
        top: 6px;
        right: 16px;
        cursor: pointer;
        color: var(--colors-common-text-standard-default);
    }
    &__icon {
        color: var(--colors-common-background-darkest-lighter);
    }
}
</style>
